// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b50e995d","554":"0358077b"}[chunkId] + ".chunk.js";
};